<h2 mat-dialog-title class="dialog-title">
  {{ pageName }} / Table Columns
  <mat-icon mat-dialog-close style="color: #000000; cursor: pointer;">close</mat-icon>
</h2>

<div mat-dialog-content class="dialog-content">
  <!-- Available Columns -->
  <div class="column-section available">
    <h3>COLUMNS
      <span>({{ selectedColumns.length }} of {{ defaultColumns.length }})</span>
    </h3>

    <!-- <div style="position: relative; width: 100%;">
      <span style="position: absolute; top: 7px; left: 6px; pointer-events: none;">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
            stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M11.3335 11.332L14.0002 13.9987" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
      <input type="search" class="du-preferences-search-input" placeholder="Search columns" [(ngModel)]="searchTerm" />
    </div> -->


    <!-- Select All Checkbox -->
    <mat-checkbox class="select-all-checkbox" [checked]="areAllSelected()" [indeterminate]="someSelected()"
      (change)="toggleSelectAll($event.checked)">
      Select All
    </mat-checkbox>

   <div class="column-header-with-search">
  <span class="column-name-label">Column name</span>
  <div class="search-container">
    <span class="search-icon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
          stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.3335 11.332L14.0002 13.9987" stroke="#8A98AB" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
    <input
      type="search"
      class="du-preferences-search-input"
      placeholder="Search columns"
      [(ngModel)]="searchTerm"
    />
  </div>
</div>

    <div class="scroll-area">
      <div *ngFor="let col of filteredColumns" class="checkbox-item du-preference-checkbox">
        <mat-checkbox [checked]="isSelected(col.headerName || col.field)"
          (change)="toggleColumn(col.headerName || col.field)">
          {{ col.headerName || col.field }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Selected Columns -->
  <div class="column-section selected">
    <h3>
      SELECTED COLUMNS
      <span>({{ selectedColumns.length }})</span>
    </h3>
    <div class="column-header-with-search selected-header">
      <span class="header-name">Column name</span>
      <span class="header-remove">Remove</span>
    </div>
    <div class="scroll-area" cdkDropList [cdkDropListData]="selectedColumns" (cdkDropListDropped)="dropColumn($event)"
      cdkDropListAutoScroll>
      <div class="selected-row" *ngFor="let col of selectedColumns" cdkDrag>
        <div class="column-name d-flex align-items-center" cdkDragHandle>
          <mat-icon class="drag-icon">drag_indicator</mat-icon>
          {{ col.name }}
        </div>
        <div class="column-remove">
          <button mat-icon-button (click)="removeColumn(col.name)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <ng-template cdkDragPreview>
          <div class="selected-row">
            <div class="column-name d-flex align-items-center" cdkDragHandle>
              <mat-icon class="drag-icon">drag_indicator</mat-icon>
              {{ col.name }}
            </div>
            <div class="column-remove">
              <button mat-icon-button>
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div mat-dialog-actions align="end" class="dialog-actions">
  <!-- <button mat-button (click)="restoreDefaults()">Restore Defaults</button> -->
  <button mat-flat-button color="primary"  (click)="apply()" [disabled]="selectedColumns.length === 0">Apply</button>
</div>
